// ** React Imports
import { useCallback } from "react";

// ** Custom Components
import UserTileForUsersViewGrid from "components/user/UserTileForUsersViewGrid";

import { StyledGridList } from "components/user/Browser/styles";

// #####################################################

const SimpleUsersGrid = ({ items }) => {
	const renderSimpleUsersGrid = useCallback(() => {
		return items.map((item, index) => {
			return (
				<li key={item.id}>
					<UserTileForUsersViewGrid
						user={item}
						avatarProps={{ borderSize: true }}
					/>
				</li>
			);
		});
	}, [items]);

	// #####################################################

	return <StyledGridList inProfile>{renderSimpleUsersGrid()}</StyledGridList>;
};

// #####################################################

export default SimpleUsersGrid;

// #####################################################
